import { makeAd, showLoadMoreAd } from "../../../../core/lib/ads";
import Ad from "../../../../core/page-blocks/Ad.component";

interface BatchIdParams {
    adInsertionPosition: number;
    blockId: string;
    itemIdx: number;
}

interface CoastFeedAdItemProps extends BatchIdParams {
    summaryAdPosition?: string;
    thumbAdPosition?: string;
}

interface CoastFeedLoadMoreAdProps extends BatchIdParams {
    adPosition?: string;
}

type CoastFeedAdsProps = Omit<CoastFeedAdItemProps, "adInsertionPosition"> &
    Omit<CoastFeedLoadMoreAdProps, "adInsertionPosition"> & {
        loadMoreAdInsertionPosition?: number;
        itemAdInsertionPosition?: number;
        offsetLoadMore?: boolean;
        includeItemAd?: boolean;
        blockSize: number;
        itemCount: number;
    };

const getBatchId = ({ blockId, itemIdx, adInsertionPosition }: BatchIdParams) =>
    `${blockId}-${Math.ceil(itemIdx / adInsertionPosition)}`;

export const CoastFeedAdItem = ({
    summaryAdPosition = "5052",
    thumbAdPosition = "3309",
    ...batchIdParams
}: CoastFeedAdItemProps) => {
    const batchId = getBatchId(batchIdParams);

    return (
        <div className="coast-item-ad-container">
            <Ad isPrimary={false} block={makeAd(thumbAdPosition, 0)} batchId={batchId} />
            <Ad isPrimary={false} block={makeAd(summaryAdPosition, 0)} batchId={batchId} />
        </div>
    );
};

export const CoastFeedLoadMoreAd = ({ adPosition = "3306", ...batchIdParams }: CoastFeedLoadMoreAdProps) => (
    <div className="load-more-ad">
        <Ad isPrimary={false} block={makeAd(adPosition, 0)} batchId={getBatchId(batchIdParams)} />
    </div>
);

const loadMoreAdIdx = (idx: number, doOffset: boolean) => (doOffset ? idx + 1 : idx);

export const CoastFeedAds = ({
    blockSize,
    itemCount,
    itemIdx,
    blockId,
    includeItemAd = true,
    itemAdInsertionPosition = 4,
    offsetLoadMore = false,
    loadMoreAdInsertionPosition = blockSize,
}: CoastFeedAdsProps) => (
    <>
        {includeItemAd && itemIdx % blockSize === itemAdInsertionPosition ? (
            <CoastFeedAdItem itemIdx={itemIdx} blockId={blockId} adInsertionPosition={itemAdInsertionPosition} />
        ) : null}

        {showLoadMoreAd(itemCount, loadMoreAdInsertionPosition, loadMoreAdIdx(itemIdx, offsetLoadMore), true) ? (
            <CoastFeedLoadMoreAd
                adInsertionPosition={loadMoreAdInsertionPosition}
                blockId={blockId}
                itemIdx={itemIdx}
            />
        ) : null}
    </>
);
